import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, CATEGORIES } from "../lib/shop";
import { useT, localizedProduct } from "../lib/i18n";
import ProductCard from "../components/ProductCard";
import SEO from "../components/SEO";

export default function Category() {
  const { slug } = useParams();
  const { t, lang } = useT();
  const cat = CATEGORIES.find((c) => c.slug === slug);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/products?category=${slug}`)
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [slug]);

  if (!cat) return <div className="max-w-7xl mx-auto px-6 py-32">{t("cat.empty")}</div>;

  const title = slug === "cutite" ? t("nav.knives.long") : t("nav.tools.long");
  const subtitle = slug === "cutite" ? t("cat.cutite.desc") : t("cat.scule.desc");
  const seoDescription = slug === "cutite"
    ? "Cuțite profesionale de bucătărie din oțel japonez HRC 60, călire laser, mâner deluxe Pakka."
    : "Truse de scule pentru uz casnic și profesional: 102 și 108 piese, crom-vanadium.";

  return (
    <div data-testid={`category-page-${slug}`}>
      <SEO title={title} description={seoDescription} image={cat.image} path={`/categorie/${slug}`} />
      <section className="border-b border-gray-200 bg-silver-shimmer">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
          <nav className="text-xs uppercase tracking-[0.2em] text-gray-500 flex gap-2 items-center mb-6">
            <Link to="/" className="hover:text-gray-900">{t("cat.crumb.home")}</Link>
            <span>/</span>
            <span className="text-gray-900">{title}</span>
          </nav>
          <h1 className="font-display text-5xl md:text-7xl font-black tracking-tighter leading-none">{title}</h1>
          <p className="mt-4 text-gray-600 max-w-xl">{subtitle}</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24">
        {loading ? (
          <div className="text-gray-400 text-sm uppercase tracking-widest">{t("product.loading")}</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-testid="category-grid">
            {products.map((p, i) => <ProductCard key={p.id} p={localizedProduct(p, lang)} index={i} />)}
          </div>
        )}
      </section>
    </div>
  );
}
